module.exports = __webpack_public_path__ + "static/media/image_1.793a4ac5.svg";